/** TRACI-628: shown to the shopper when a staff member sends their chat to a rep. True whatever
 * the rep desk then answers (a closed or busy desk gets the same decline a shopper press gets). */
export const STAFF_SENT_NOTICE = 'A Tire Rack team member asked us to connect you with a person.';
